/*
 * @Descripttion:
 * @Author: dengyao
 * @Date: 2024-05-31 13:43:44
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-24 16:58:24
 */
import request from '@/service/request'
export default class commonService {
  /**
   * 获取数据字典
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post('/dict-value/getDictValue', data)
  }
  /**
   * 根据字典type获取字典数据
   * @param data
   * @returns
   */
  static getListDictDataList(data: any): Promise<any> {
    return request.post('/dict-value/listDictData', data)
  }
  /**
   * 文件上传
   * @param data
   * @returns
   */
  static uploadFile(data: FormData): Promise<any> {
    return request.upload('/architecture/upload', data)
  }
  /**
   * 获取 OSS 预签名上传 URL（直传 OSS）
   * @param data - { size, fileName, fileLifeEnum, duration, contentType }
   * @returns { url, key, 'content-type' }
   */
  static getUploadUrl(data: any): Promise<any> {
    return request.post('/architecture/getUploadUrl', data)
  }
  /**
   * 查询客户信息
   * @param data - 请求参数
   */
  static getStationDetail(data: any): Promise<any> {
    return request.get('/station/detail', data)
  }
  /**
   * 获取区域地址列表 IDN使用三级全量地址
   * @returns
   */
  static getAreaAddressList(): Promise<any> {
    return request.post('/address/versionUpdate')
  }
  /**
   * 获取区域地址列表 JSON格式
   * @param url
   * @returns
   */
  static getAddressJson(url:string): Promise<any> {
    return request.get(url)
  }
}
